import Vue from 'vue'
import Element from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css';
import '../style/index.css'

Vue.use(Element, { size: 'small' })
